import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagNo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-no",
	viewBox: "0 0 640 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ed2939",
			d: "M0 0h640v480H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M180 0h120v480H180z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 180h640v120H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002664",
			d: "M210 0h60v480h-60z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002664",
			d: "M0 210h640v60H0z"
		})
	]
});
export default SvgFlagNo;
